import { API_ENDPOINTS } from "constants/http-endpoints";

export const getCurlCommands = (defaultAPIKey: string) => ({
  transactions: {
      GET: `curl -X GET ${API_ENDPOINTS.REVENUE}/transactions \\
      -H "x-api-key: ${defaultAPIKey}" \\
      -H "Content-Type: application/json"`,
        POST: `curl -X POST ${API_ENDPOINTS.REVENUE}/transactions \\
      -H "x-api-key: ${defaultAPIKey}" \\
      -H "Content-Type: application/json" \\
      -d '{
      "transaction_id": "txn_123",
      "customer_id": "cust_123",             //customer id in your billing system (can be same as group_id)
      "group_id": "group_456",               //group_id in product telemetry
      "customer_name": "John Doe",
      "invoice_id": "inv_123",
      "type": "payment",                     // payment, refund
      "status": "paid",                      // paid, cancelled, failed, refund, charged_back
      "transaction_date": "2024-01-15T14:30:00Z",
      "amount": 99.99,
      "currency": "USD",                     // USD, EUR, GBP | Default: USD
      "payment_method": "credit_card",       // credit_card, paypal, stripe
      "transaction_fee": 2.99,
      "tax_amount": 5.00,
      "discount_amount": 10.00,
      "term_frequency": 1,
      "term_unit": "month",                  // day, week, month, year | Default: month
      "period_start_date": "2024-01-01T00:00:00Z",
      "period_end_date": "2024-01-31T23:59:59Z",
      "line_item_type": "subscription"       // Must be "subscription" for recurring revenue or "one_time" for setup or any professional charges
    }'`,
      PUT: `curl -X PUT ${API_ENDPOINTS.REVENUE}/transactions \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
      "transaction_id": "txn_123",
      "status": "paid",                      // paid, cancelled, failed, refund, charged_back
      "type": "payment",                     // payment, refund
      "date": "2024-01-20T10:30:00Z",
      "amount": 149.99,
      "currency": "USD",                     // USD, EUR, GBP | Default: USD
      "payment_method": "credit_card",       // credit_card, paypal, stripe
      "transaction_fee": 3.50,
      "tax_amount": 7.50,
      "discount_amount": 15.00,
      "term_frequency": 1,                  // Default: 1
      "term_unit": "month",                  // day, week, month, year | Default: month
      "period_start_date": "2024-01-01T00:00:00Z",
      "period_end_date": "2024-01-31T23:59:59Z",
      "line_item_type": "subscription"       // Must be "subscription" for recurring revenue or "one_time" for setup or any professional charges
    }'`,
      DELETE: `curl -X DELETE  ${API_ENDPOINTS.REVENUE}/transactions \\
    -H 'x-api-key: ${defaultAPIKey}' \\
    -H 'Content-Type: application/json' \\
    -d '{
        "transaction_id": "txn_123"
        }'`
},
  invoices: {
    GET: `curl -X GET ${API_ENDPOINTS.REVENUE}/invoices \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json"`,
    POST: `curl -X POST ${API_ENDPOINTS.REVENUE}/invoices \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
      "invoice_id": "inv_123",
      "customer_id": "cust_123",            //customer id in your billing system
      "group_id": "group_123",               //group_id in product telemetry
      "issue_date": "2024-01-15T00:00:00Z",
      "amount": 299.99,
      "currency": "USD",                     // USD, EUR, GBP | Default: USD
      "due_date": "2024-02-15T00:00:00Z"   //optional
    }'`,
    PUT: `curl -X PUT ${API_ENDPOINTS.REVENUE}/invoices \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
      "invoice_id": "inv_123",
      "issue_date": "2024-01-15T00:00:00Z",
      "amount": 349.99,
      "currency": "USD",                     // USD, EUR, GBP | Default: USD
      "due_date": "2024-02-15T00:00:00Z"
    }'`,
    DELETE: `curl -X DELETE ${API_ENDPOINTS.REVENUE}/invoices \\
    -H 'x-api-key: ${defaultAPIKey}' \\
    -H 'Content-Type: application/json' \\
    -d '{
        "invoice_id": "inv_123"
    }'`
  },
  subscriptions: {
    POST: `curl -X POST ${API_ENDPOINTS.REVENUE}/subscriptions \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "subscription_id": "sub_123",
    "customer_id": "cust_123",
    "group_id": "group_456",
    "status": "active",
    "currency": "USD",
    "start_date": "2024-01-15T00:00:00Z",
    "ended_at": "2025-01-15T00:00:00Z",
    "trial_start_date": "2024-01-01T00:00:00Z",
    "trial_end_date": "2024-01-14T23:59:59Z",
    "current_period_start": "2024-01-15T00:00:00Z",
    "current_period_end": "2024-02-14T23:59:59Z",
    "cancelled_at": null,
    "cancellation_comment": "",
    "create_date": "2024-01-15T00:00:00Z",
    "updated_date": "2024-01-15T00:00:00Z"
  }'`,
    PUT: `curl -X PUT ${API_ENDPOINTS.REVENUE}/subscriptions \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "subscription_id": "sub_123",
    "status": "cancelled",
    "currency": "USD",
    "current_period_start": "2024-01-15T00:00:00Z",
    "current_period_end": "2024-02-14T23:59:59Z",
    "cancelled_at": "2024-02-01T12:00:00Z",
    "ended_at": "2024-02-01T12:00:00Z",
    "cancellation_comment": "Customer requested cancellation",
    "updated_date": "2024-02-01T12:00:00Z"
  }'`,
    DELETE: `curl -X DELETE ${API_ENDPOINTS.REVENUE}/subscriptions \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "subscription_id": "sub_123"
  }'`
  },
  'subscription-items': {
    POST: `curl -X POST ${API_ENDPOINTS.REVENUE}/subscription-items \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "subscription_item_id": "si_123",
    "subscription_id": "sub_123",
    "customer_id": "cust_123",
    "plan_id": "plan_pro_monthly",
    "price_id": "price_123",
    "term_unit": "month",
    "term_frequency": "1",
    "start_date": "2024-01-15T00:00:00Z",
    "status": "active",
    "created_date": "2024-01-15T00:00:00Z",
    "ended_at": "2025-01-15T00:00:00Z",
    "quantity": 1,
    "trial_start_date": "2024-01-01T00:00:00Z",
    "trial_end_date": "2024-01-14T23:59:59Z",
    "cancelled_at": null,
    "current_period_start": "2024-01-15T00:00:00Z",
    "current_period_end": "2024-02-14T23:59:59Z",
    "updated_date": "2024-01-15T00:00:00Z"
  }'`,
    PUT: `curl -X PUT ${API_ENDPOINTS.REVENUE}/subscription-items \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "subscription_item_id": "si_123",
    "subscription_id": "sub_123",
    "plan_id": "plan_pro_monthly",
    "price_id": "price_456",
    "term_unit": "month",
    "term_frequency": "1",
    "start_date": "2024-01-15T00:00:00Z",
    "status": "active",
    "quantity": 2,
    "current_period_start": "2024-01-15T00:00:00Z",
    "current_period_end": "2024-02-14T23:59:59Z",
    "updated_date": "2024-02-01T00:00:00Z"
  }'`,
    DELETE: `curl -X DELETE ${API_ENDPOINTS.REVENUE}/subscription-items \\
    -H "x-api-key: ${defaultAPIKey}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "subscription_item_id": "si_123"
  }'`
  }
  });
